export default __webpack_public_path__ + "static/media/TLC.b4a220c3.svg";